export default __webpack_public_path__ + "static/media/actions-unicrypt.43ff034d.svg";